import React, { Component } from 'react';
import { connect } from 'react-redux';

import 'react-big-calendar/lib/css/react-big-calendar.css';

import EventCalendarBasic from 'components/shared/EventCalendarBasic';
import AddEventDialog from 'components/landlord_app/calendar/OldEventsAmenities/AddEventDialog';

import * as landlordPropertiesActions from 'actions/landlordPropertiesActions';
import * as siteEventActions from 'actions/siteEventActions';

import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';

let CalendarKiosk = class EventCalendar extends Component {
  state = {
    showAddDialog: false,
    showEventDetailsDialog: false,
    confirmDelete: false,
  };

  UNSAFE_componentWillMount() {
    this.props.getProperties({ for_multiselect: true });
    this.props.clearEvents();
  }

  onPropertySelect = property => {
    let propertyId = null;
    if (property && property.value) {
      propertyId = Number(property.value);
      this.props.getEvents(propertyId);
    } else {
      this.props.clearEvents();
    }
    this.setState({ propertyId: propertyId });
  };

  toggleAddEvent = () => {
    this.setState(prevState => ({ showAddDialog: !prevState.showAddDialog }));
  };

  onComplete = () => {
    if (!this.state.propertyId) return;
    this.props.getEvents(this.state.propertyId);
  };

  render() {
    return (
      <div className="body" role="main">
        <div className="centers">
          <div style={{ height: 'calc(100% - 150px)' }}>
            <AddEventDialog
              isOpen={this.state.showAddDialog}
              toggleDialog={this.toggleAddEvent}
              properties={this.props.properties}
              propertyId={this.state.propertyId}
              initialValues={{ properties: [] }}
              toggleDetailsDialog={this.toggleEventDetails}
              onComplete={this.onComplete}
              isAmenity={true}
              step={2}
            />
            <div style={{ marginBottom: '25px' }}>
              <FlatButton
                label="Add Event"
                type="submit"
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                onClick={this.toggleAddEvent}
                style={{
                  color: 'white',
                  float: 'right',
                  height: '30px',
                  fontSize: '13px',
                  lineHeight: '30px',
                  marginTop: '3px',
                  mariginRight: '0 !important',
                }}
              />
              <span className="page-title">Calendar</span>
            </div>

            <EventCalendarBasic
              properties={this.props.properties}
              siteEvents={this.props.siteEvents}
              onPropertySelect={this.onPropertySelect}
            />
          </div>
        </div>
      </div>
    );
  }
};

CalendarKiosk = connect(
  store => ({
    properties: store.landlordProperties.properties,
    siteEvents: store.siteEvent.siteEvents,
  }),
  { ...landlordPropertiesActions, ...siteEventActions }
)(CalendarKiosk);

export default CalendarKiosk;
